// ------------
document.addEventListener("DOMContentLoaded",()=>{
    const mainContainer = document.querySelector('.new-mob-bottom-main');
    if(location.pathname.includes("/collections/")){
        mainContainer.querySelector("li[data-name='collection']").classList.add('active')
    }
    if(location.pathname.includes("/stores")){
        console.log("stores")
        mainContainer.querySelector("li[data-name='location']").classList.add('active')
    }
    if(location.pathname.includes("/swym-wishlist")){
        // mainContainer.querySelector("li[data-name='wishlist']").classList.add('active');
    }


let lastScrollTop = 0;

window.addEventListener('scroll', () => {
  let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

  if (currentScroll > lastScrollTop) {
    // Scrolling down
    mainContainer.classList.add('hide');
  } else {
    // Scrolling up
    mainContainer.classList.remove('hide');
  }

  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Prevent negative scroll
});
});


 // test EDD

// Fetch user's pincode with caching
async function getUserPincode() {
    const cachedPincode = localStorage.getItem('user_pincode');
    if (cachedPincode) {
        return cachedPincode;
    }
    try {
        const res = await fetch('https://ipapi.co/json/');
        const data = await res.json();
        const pincode = data.postal;
        localStorage.setItem('user_pincode', pincode);

        return pincode;
    } catch (err) {
        console.error("Error fetching pincode:", err);
        return null;
    }
}

// Get predicted delivery date
async function getDeliveryDate(eddData) {
    if (!eddData.drop_pincode) {
        const pincode = await getUserPincode();
        eddData.drop_pincode = pincode;
    }

    try {
        const res = await fetch(
            'https://ds.clickpost.in/api/v2/predicted_sla_api/?key=d8c395a7-ee02-42c6-a1ef-f4e370d879e0&check_drop_pincode_validity=true',
            {
                method: 'POST',
                headers: {'accept':'application/json','content-type':'application/json'},
                body: JSON.stringify([eddData])
            }
        ).then(r => r.json());
        if (res.result?.length) {
            // Helper function to add ordinal suffix to a day
            function getOrdinal(day) {
                if (day > 3 && day < 21) return day + 'th'; // 11th-20th
                switch (day % 10) {
                    case 1: return day + 'st';
                    case 2: return day + 'nd';
                    case 3: return day + 'rd';
                    default: return day + 'th';
                }
            }

            // Month names array
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

            // Calculate predicted delivery dates
            const pickupMin = new Date(eddData.pickup_date || new Date());
            pickupMin.setDate(pickupMin.getDate() + res.result[0].predicted_sla_min);

            const pickupMax = new Date(eddData.pickup_date || new Date());
            pickupMax.setDate(pickupMax.getDate() + res.result[0].predicted_sla_max);

            // Extract day, month, year
            const dayMin = pickupMin.getDate();
            const monthMin = pickupMin.getMonth();
            const yearMin = pickupMin.getFullYear();

            const dayMax = pickupMax.getDate();
            const monthMax = pickupMax.getMonth();
            const yearMax = pickupMax.getFullYear();

            // Build human-readable string
            let deliveryMessage = '';
            if(getOrdinal(dayMin) === getOrdinal(dayMax)){
                deliveryMessage = `${getOrdinal(dayMax)} ${monthNames[monthMin]}`;
                document.querySelector(".delivery-date-info p").textContent = `Delivery on`;
            }
            else if (monthMin === monthMax && yearMin === yearMax) {
                // Same month & year
                deliveryMessage = `${getOrdinal(dayMin)}-${getOrdinal(dayMax)} ${monthNames[monthMin]}`;
            } else {
                // Different month or year
                deliveryMessage = `${getOrdinal(dayMin)} ${monthNames[monthMin]} - ${getOrdinal(dayMax)} ${monthNames[monthMax]}`;
            }

            console.log(deliveryMessage);
            let defaultPdpDate = document.querySelector("#delivery-date-default");
            defaultPdpDate.innerHTML = `${deliveryMessage}`;
            defaultPdpDate.setAttribute("style","opacity:1");
            document.querySelector("#delivery-date").textContent = `${deliveryMessage}`;

        } else {
            console.log("No SLA data returned");
        }
    } catch (err) {
        console.error("Error fetching SLA:", err);
    }
}

document.addEventListener("DOMContentLoaded",()=>{
    if(!location.pathname.includes("/products/")) return;
    const eddData = {pickup_pincode: '110048'}; // store pincode
    getDeliveryDate(eddData);
})

function updatePincode(){
    const pinVal = document.querySelector(".fix-pin-main input");
    if(!pinVal.value || pinVal.value.length!=6) return;
    localStorage.setItem('user_pincode',pinVal.value)
    pinVal.value = "";
    document.querySelector('.fix-pin-wrapper').classList.add('hide');
    const eddData = {pickup_pincode: '110048'};
    getDeliveryDate(eddData);
}

// test EDD
// ------------ Quick Add Model EDD----------------- 
function checkOpenModal(target){
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'open'
      ) {
        if (target.hasAttribute('open')) {
            const eddData = {pickup_pincode: '110048'}; // store pincode
            getDeliveryDate(eddData);
        }
      }
    }
  });

  observer.observe(target, {
    attributes: true,
    attributeFilter: ['open'],
  });
}
document.addEventListener("DOMContentLoaded",()=>{
    document.querySelectorAll("quick-add-modal").forEach((model)=>{
        checkOpenModal(model)
    })
})
// ------------ Quick Add Model EDD----------------- 


// image-new-slider
document.addEventListener("DOMContentLoaded",()=>{
const target = document.querySelector("product-recommendations");

if (target) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
        obs.disconnect();
      if (mutation.type === "childList") {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
      }
    }
  });

  observer.observe(target, {
    childList: true, // watch children add/remove
  });
}
const collectionProducts = document.querySelector(".active-facets.active-facets-desktop");
if (collectionProducts) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
    }
  });

  observer.observe(collectionProducts, {
    childList: true, // watch children add/remove,
    subtree: true,
  });
}


document.querySelectorAll('.productSwiper').forEach((slider) => {
      new Swiper(slider, {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  allowTouchMove: true, // ✅ enable touch
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: slider.querySelector('.swiper-button-next'),
    prevEl: slider.querySelector('.swiper-button-prev'),
  },
});

    });

    // for product-rec

});



// image-new-slider


const lenis = new Lenis({
    smoothWheel: !0,
    smoothTouch: !1,
    normalizeWheel: !0,
    ignore: el => el.classList.contains("scroll-section")
});
lenis.on("scroll", ScrollTrigger.update),
gsap.ticker.add(time => {
    lenis.raf(time * 700)
});

// ============= search desktop container ===============

// ============= search desktop container ===============


// ---------- Header-Scroll-effect Start ----------

function toggleNotiBox() {
document.querySelector('.my-notification-box').classList.toggle('active');
}


function manageScrollChages(){
    // Notify manage start
    if(scrollY>(innerHeight*0.4) && document.querySelector(".my-notification-box.active")){
        document.querySelector(".my-notification-box.active").classList.remove("active")
    }
    if(scrollY>(innerHeight*0.4) && document.querySelector(".my-notification-box.visible")){
        document.querySelector(".my-notification-box").classList.remove("visible");
    }else if(scrollY<(innerHeight*0.4) && !document.querySelector(".my-notification-box").classList.contains("visible")){
        document.querySelector(".my-notification-box").classList.add("visible");
    }
    // Notify manage start
        const searchContainer = document.getElementById('searchContainer');
    
    // manage Header Color
    if(scrollY>20 && !document.querySelector(".header.scroll-on")){
        document.querySelector(".header").classList.add("scroll-on")
    }
    if(scrollY<20 && document.querySelector(".header.scroll-on") && !searchContainer.classList.contains('active')){
        document.querySelector(".header.scroll-on").classList.remove("scroll-on");
    }
    // manage Header Color
}

document.addEventListener("DOMContentLoaded",()=>{
    if(location.pathname=="/"){
        document.querySelector(".my-notification-box").setAttribute("style","display:flex");
    }
    manageScrollChages()
});
document.addEventListener("scroll",()=>manageScrollChages());

// ---------- Header-Scroll-effect End ----------




// ---------- MOUSE SCROLL-X ----------

function enableLeftClickDragScroll(container) {
    if (!container)
        return;
    let isDragging = !1
      , dragStarted = !1
      , startX = 0
      , scrollStart = 0;
    const dragThreshold = 5;
    container.addEventListener("mousedown", e => {
        e.button === 0 && (isDragging = !0,
        dragStarted = !1,
        startX = e.pageX,
        scrollStart = container.scrollLeft,
        container.classList.add("is-dragging"),
        e.preventDefault())
    }
    ),
    container.addEventListener("mousemove", e => {
        if (!isDragging)
            return;
        const deltaX = e.pageX - startX;
        !dragStarted && Math.abs(deltaX) > dragThreshold && (dragStarted = !0),
        dragStarted && (container.scrollLeft = scrollStart - deltaX)
    }
    ),
    container.addEventListener("mouseup", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("mouseleave", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("click", e => {
        dragStarted && (e.preventDefault(),
        e.stopPropagation(),
        dragStarted = !1)
    }
    ),
    container.classList.add("is-draggable")
}
function waitForElementAndInit(selector) {
    document.querySelectorAll(selector).forEach(el => {
        el._dragInitialized || (enableLeftClickDragScroll(el),
        el._dragInitialized = !0)
    }
    ),
    new MutationObserver(mutations => {
        for (const mutation of mutations)
            mutation.addedNodes.forEach(node => {
                node instanceof HTMLElement && (node.matches(selector) && !node._dragInitialized && (enableLeftClickDragScroll(node),
                node._dragInitialized = !0),
                node.querySelectorAll?.(selector)?.forEach(el => {
                    el._dragInitialized || (enableLeftClickDragScroll(el),
                    el._dragInitialized = !0)
                }
                ))
            }
            )
    }
    ).observe(document.body, {
        childList: !0,
        subtree: !0
    })
}
document.addEventListener("DOMContentLoaded", () => {
    [".collection .product-grid.slider",".home-tab-products", ".cust-accordion ul", ".gallery_hero_container", ".stores-main .store-cards"," .my-recent-view-section .grid.product-grid",".cust-exclusive-sec .product-grid"].forEach(selector => {
        waitForElementAndInit(selector)
    }
    )
}
);

// ---------- MOUSE SCROLL-X ----------




// =============== hamburger =================

const toggleBtn = document.querySelector('.toggle-btn-d');
const drawer = document.querySelector('.header_cont-drawer');
const overlay = document.querySelector('.drawer-overlay');

function menuOpen() {
  toggleBtn.classList.toggle('active');
  drawer.classList.toggle('active-cont');
  overlay.classList.toggle('active');

  // Prevent body scroll
  if (drawer.classList.contains('active-cont')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}

toggleBtn.addEventListener('click', menuOpen);

/* Close drawer when overlay is clicked */
overlay.addEventListener('click', menuOpen);

// =============== hamburger =================


// =============== toggleColGrid =================

function toggleColGrid(el){
    document.querySelector(".cust-collection-1").classList.toggle("spot-view")
    if(document.querySelector(".cust-collection-1").classList.contains("spot-view")){
        lenis.scrollTo(0)
    }
}

// =============== toggleColGrid =================


// for dots
 
 
 
 
function snapScrollLeft(el){
    const mediaWrapper = el.closest(".card__inner");
    const dotsWrapper = mediaWrapper.querySelector(".card-img-dots");
    const galleryWrapper = mediaWrapper.querySelector(".card-img-ul");
   
    const imgCount = dotsWrapper.querySelectorAll("li").length;
    const galleryWidth = galleryWrapper.scrollWidth;
    const scrollAmount = galleryWidth / imgCount;
   
    galleryWrapper.scrollBy({
        left: -scrollAmount,
        behavior: "smooth"
    });
   
    const current = dotsWrapper.querySelector("li.active");
    const previous = current.previousElementSibling;
    const previoustoPrev = previous ? previous.previousElementSibling : null;
    const next = el.nextElementSibling;
 
    if (previous) {
        current.classList.remove("active");
        previous.classList.add("active");
    }
   
    if(next){
        next.style.opacity = "1";
    }
   
    if(!previoustoPrev){
        el.style.opacity = "0";
    }
}
 
 
function snapScrollRight(el){
    const mediaWrapper = el.closest(".card__inner");
    const dotsWrapper = mediaWrapper.querySelector(".card-img-dots");
    const galleryWrapper = mediaWrapper.querySelector(".card-img-ul");
   
    const imgCount = dotsWrapper.querySelectorAll("li").length;
    const galleryWidth = galleryWrapper.scrollWidth;
    const scrollAmount = galleryWidth / imgCount;
   
    galleryWrapper.scrollBy({
        left: scrollAmount,
        behavior: "smooth"
    });
   
    const current = dotsWrapper.querySelector("li.active");
    const prev = el.previousElementSibling;
    const next = current.nextElementSibling;
    const nexttoNext = next ? next.nextElementSibling : null;
   
    if (next) {
        current.classList.remove("active");
        next.classList.add("active");
    }
   
    if(prev){
        prev.style.opacity = "1";
    }
   
    if(!nexttoNext){
        el.style.opacity = "0";
    }
}
 
 
 
// -------------------------------------------
// iOS-SAFE REPLACEMENT FOR THE "scrollend" EVENT
// -------------------------------------------
 
function onScrollEnd(element, callback, delay = 0) {
    let timeout;
    element.addEventListener("scroll", () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback();
        }, delay);
    });
}
 
 
 
// ---------------------
// DOTS + BUTTON SYNCING
// ---------------------
 
function connectDotsChange(){
    const Cardcontainer = document.querySelectorAll('.card-img-ul');
   
    Cardcontainer.forEach(card => {
        const cardWrapper = card.closest(".card");
        const cardDots = cardWrapper.querySelector(".card-img-dots");
        const items = card.querySelectorAll('.card-img-ul li');
       
        // REPLACED scrollend → onScrollEnd
        onScrollEnd(card, () => {
            const liWid = card.clientWidth;
            const snapLi = Math.round(card.scrollLeft / liWid) + 1;
           
            // Update dots
            cardDots.querySelector("li.active")?.classList.remove("active");
            cardDots.querySelector(`li[data-val='${snapLi}']`)?.classList.add("active");
           
            // Left button visibility
            const leftBtn = cardWrapper.querySelector('.ci-left-btn');
            leftBtn.style.opacity = snapLi === 1 ? "0" : "1";
           
            // Right button visibility
            const rightBtn = cardWrapper.querySelector('.ci-right-btn');
            rightBtn.style.opacity = snapLi === items.length ? "0" : "1";
        });
    });
}
 
 
 
// ---------------------
// OBSERVER FOR DYNAMIC CONTENT
// ---------------------
 
function setCardDots(elTag){
    new MutationObserver(() => {
        connectDotsChange();
    }).observe(elTag, {
        childList: true,
        subtree: true,
    });
}

 
 
 
// ---------------------
// INITIALIZATION
// ---------------------
 
document.addEventListener("DOMContentLoaded", () => {
    connectDotsChange();
   
    if (location.pathname.includes("/collections/")) {
        const filtData = document.querySelector('aside');
        if (filtData) setCardDots(filtData);
    }
   
});
 
// for dots


// ------------

// <!-- // menu accordion start -->

document.addEventListener("DOMContentLoaded",()=>{
(function() {
    const initializeAccordion = () => {
        const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");
        // Remove previous event listeners to prevent stacking
        accordionItemHeaders.forEach(header => {
          header.removeEventListener("click", toggleAccordion);
        });

        if (accordionItemHeaders.length > 0) {
            accordionItemHeaders.forEach((accordionItemHeader) => {
                accordionItemHeader.addEventListener("click", toggleAccordion);
            });
        }
    };

    const toggleAccordion = (event) => {
        const accordionItemHeader = event.currentTarget;
        const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");

        if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
            currentlyActiveAccordionItemHeader.classList.remove("active");
            currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }

        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
            accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px"; // Set max-height to scroll height
        } else {
            accordionItemBody.style.maxHeight = 0;
        }
    };

    // Call the function to initialize the accordion
    initializeAccordion();
})();
})

// <!-- // menu accordion end -->


// ======== collection filt and spot hide for search close -- start ==========

document.addEventListener("DOMContentLoaded", function () {
    if(location.pathname.includes("/collections/") && innerWidth<950){
    const searchEl = document.querySelector('.search_content');
    const fixedFilt = document.querySelector('.col-header-top-right');    
    new MutationObserver(mutations => {
        const isOpen = document.querySelector('.search_content').classList.contains("active");
        if(isOpen){
            fixedFilt.style.display="none";
        }else{
            fixedFilt.style.display="flex";
        }
    }).observe(searchEl, {
        attributes: true
    });
    }   
     // ================== Filter Drawer ===============

  const filter = document.querySelector(".mobile-facets__disclosure");
  const facets = document.querySelectorAll(".mobile-facets__details");

  filter && filter.addEventListener("click", () => {
    facets.forEach((facet) => {
      facet.setAttribute("open", true);
    })
  })

// ================== Filter Drawer ===============
})

// ======== collection filt and spot hide for search close -- end ==========



// --- hide filt when open cart [MOB] ---
document.addEventListener("DOMContentLoaded", function () {
    if(location.pathname.includes("/collections/") && innerWidth<950){
    const CartDrawer = document.querySelector('cart-drawer.drawer');
    const fixedFilt = document.querySelector('.col-header-top-right');    
    new MutationObserver(mutations => {
        const isOpen = document.querySelector('cart-drawer.drawer').classList.contains("active");
        if(isOpen){
            fixedFilt.style.display="none";
        }else{
            fixedFilt.style.display="flex";
        }
    }).observe(CartDrawer, {
        attributes: true
    });
    }    
})
// --- hide filt when open cart [MOB] ---
    
// working with reload -- filter
 
// document.addEventListener('DOMContentLoaded', function () {
//     const sizeFilterInputs = document.querySelectorAll('input[name^="filter.v.option"]');
//     sizeFilterInputs.forEach(input => {
//         input.addEventListener('change', function () {
//             const form = input.closest('form');
//             const formData = new FormData(form);
//             const params = new URLSearchParams(formData);
//             // Add availability filter only if not already present
//             if (!params.has('filter.v.availability')) {
//                 params.append('filter.v.availability', '1');
//             }
//             window.location.search = params.toString();
//         });
//     });
// });


// filter Avaibility

// document.addEventListener('DOMContentLoaded', function () {
//     const filtAval = document.getElementById('Filter-filter.v.availability-mobile-1');
//     if(filtAval && !filtAval.getAttribute("checked")) {
//         filtAval.click();
//     }
// })


// filter Avaibility


// document.addEventListener('DOMContentLoaded', function () {
//     const headerModel = document.querySelector('.header_cart');
//     if (!headerModel) return;
    
//     const observer = new MutationObserver((mutations, obs) => {
//         headerModel.classList.add("show-bubble");
//         obs.disconnect(); 
//     });
    
//     observer.observe(headerModel, {
//         childList: true,
//         subtree: true,
//     });
// });



// wishList Page js
let totalItems = 0;
let inStock = 0;
let wishTotalPrice = 0;
let variantArray = []
document.addEventListener('DOMContentLoaded', function () {
    if (!location.pathname.includes("swym-wishlist")) return;
     function updateWishInfo(){
        document.querySelector('.wl-product-count span').textContent = totalItems;
        document.querySelector('.wl-product-selected span').textContent = inStock;
        document.querySelector('.wl-product-inStock span').textContent = inStock;
        document.querySelector('.wl-product-total span').textContent = ` Rs. ${wishTotalPrice.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;  
        document.querySelector('.wl-product-total-mob span').textContent = ` Rs. ${wishTotalPrice.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;  
        if(inStock>0){
           document.querySelector('.wl-product-checkOut').classList.remove('stock-out');
        }
        document.querySelector(".wl-info-wrapper").classList.add("show-info")
    }
    function calcWishData(){
        totalItems = 0;
         inStock = 0;
         wishTotalPrice = 0;
     variantArray = []
         allItems = document.querySelectorAll("swym-storefront-layout-item[data-empi]")
        document.querySelector('.header_cart').classList.add("show-bubble");
        allItems.forEach(item=>{
            updateWishSvg(item);
            totalItems++;
            let Addbutton = item.querySelector(".swym-storefront-layout-grid-item-add-to-cart-button[disabled]");
            if(!Addbutton){
                const price = item.querySelector(".swym-storefront-layout-grid-item-final-price").textContent.trim();
                const calPrice = parseInt(price.split(".")[1].replace(",",""));
                wishTotalPrice+=calPrice;
                inStock++;
                variantArray.push(item.dataset.epi);
            }
        })
        updateWishInfo()
    }



        obsTarget = document.querySelector(".swym-storefront-layout-body") 
        const observer = new MutationObserver((mutations, obs) => {
                    // console.log("Button detected inside wishlist item");
                    calcWishData()
        });

        observer.observe(obsTarget, {
            childList: true,
            subtree: true
        });
        
    });

function updateWishSvg(item) {
    const span = document.createElement("span");
    span.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18.109" height="27.084" viewBox="0 0 18.109 27.084">
  <path id="savebluonrg" d="M0,3.333A3.333,3.333,0,0,1,3.333,0H14.776a3.333,3.333,0,0,1,3.333,3.333V25.895a1.111,1.111,0,0,1-1.839.839l-4.861-4.219A3.333,3.333,0,0,0,7.1,22.462L1.819,26.827A1.111,1.111,0,0,1,0,25.971Z" fill="#FF0000"/>
</svg>`
    span.classList.add("cust-wish-remove");
    span.addEventListener("click",()=>{
        item.querySelector(".swym-storefront-layout-grid-item-option-button").click();
        document.querySelector(".swym-storefront-layout-action-tooltip-btn.remove-from-list-button").click()
    });
    item.append(span)
}
let isFree = true;
async function addProductByVariantId() {
    if(!isFree) return;
    isFree = false;
    const checkOutBtn = document.querySelector(".wl-product-checkOut").classList.add("disabled");
    try {
        const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                items: variantArray.map(id => ({
                    id,
                    quantity: 1
                }))
            })
        });
        if (!res.ok) {
            const errorData = await res.json();
            return
        }
        isFree = true;
        location.href = "/checkout"
        // updateCartDrawerUI()
    } catch {
        console.log("This product is not available")
    }
}
async function updateCartBubble() {
  const response = await fetch("/?sections=header");
  const sections = await response.json();
  const parser = new DOMParser();
  const doc = parser.parseFromString(sections.header, "text/html");
  const newCartIcon = doc.querySelector("#cart-icon-bubble");
  const currentCartIcon = document.querySelector("#cart-icon-bubble");
  if (!newCartIcon || !currentCartIcon) return;
  currentCartIcon.replaceWith(newCartIcon);
}
function updateCartDrawerUI() {
    fetch("/?section_id=cart-drawer").then(res => res.text()).then(html => {
        const newCart = new DOMParser().parseFromString(html, "text/html").querySelector("#CartDrawer")
          , currentCart = document.querySelector("#CartDrawer");
        newCart && currentCart && (currentCart.innerHTML = newCart.innerHTML);
        const cartDrawer = document.querySelector("cart-drawer");
        setTimeout(async () => {
            cartDrawer && cartDrawer.classList.add("active"),
            cartDrawer && cartDrawer.classList.remove("is-empty"),
            updateCartBubble()
        }
        , 400),
        document.querySelector("#CartDrawer-Overlay").addEventListener("click", () => {
            cartDrawer && cartDrawer.classList.remove("active")
        }
        )
    }
    ).catch(err => console.error("Failed to update cart drawer:", err))
}

// wishList Page js


// ----- collection page sticky collection bar -----
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.cust-col-header-main');

  if (!header) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      header.classList.toggle('is-sticky', !entry.isIntersecting);
    },
    { threshold: [1] }
  );

  observer.observe(header);
});
// ----- collection page sticky collection bar -----


// document.addEventListener('DOMContentLoaded', function () {
//     let isFind = false
//     setInterval(() => {
//         if(!isFind){
//             isFind = true
//             const wishCount = document.querySelector(".swym-anchor-badge.show-badge");
//             let count = wishCount.dataset.count;
//             document.querySelector(".cust-wish-count").textContent = count
//             const observer = new IntersectionObserver(
//                 () => {
//                     if(document.querySelector(".swym-anchor-badge.show-badge").textContent.trim()>0){
//                         document.querySelector(".cust-wish-count").classList.add("show")
//                         document.querySelector(".cust-wish-count").textContent = document.querySelector(".swym-anchor-badge.show-badge").textContent.trim();
//                     }else{
//                         document.querySelector(".cust-wish-count").classList.remove("show")
//                     }
//                 }
//             );

//             observer.observe(wishCount,{
//                 attributes:true
//             });
//         }
//     }, 2000);

// setTimeout(() => {
//             const wishCount = document.querySelector(".swym-anchor-badge.show-badge");
    
//  const observer = new IntersectionObserver(
//                 () => {
//                     console.log("loac")
//                     document.querySelector(".cust-wish-count").classList.add("show")
//                     document.querySelector(".cust-wish-count").textContent = document.querySelector(".swym-anchor-badge.show-badge").textContent.trim();
//                     if(document.querySelector(".swym-anchor-badge.show-badge").textContent.trim()!=0){
//                     }else{
//                         document.querySelector(".cust-wish-count").classList.remove("show")
//                     }
//                 }
//             );

//             observer.observe(wishCount);
// }, 2000);
// })

function openSizechart(el) {
    if(innerWidth<950){
        document.querySelector(".new-mob-bottom-main").setAttribute("style","display: none !important");
    }
    const productInfo = el.closest("product-info")
    const sizeChart = productInfo.querySelector(".sizechart");
    sizeChart.classList.add("active");
      // Toggle between IN and CM
      const inchToggle = sizeChart.querySelector(".size-toggle-inch");
      const cmToggle = sizeChart.querySelector(".size-toggle-cm");
      const toggleContainer = sizeChart.querySelector(".size-chart-toggle");
      const inchTable = sizeChart.querySelector('[data-table="inch"]');
      const cmTable = sizeChart.querySelector('[data-table="cm"]');
      const overlay = sizeChart.querySelector(".sizechart-overlay");
      const sizechart = sizeChart.querySelector(".sizechart");
 
      inchToggle.addEventListener("click", function () {
        if (!inchToggle.classList.contains("active")) {
          inchToggle.classList.add("active");
          cmToggle.classList.remove("active");
          toggleContainer.classList.remove("cm-active");
 
          inchTable.classList.remove("hidden");
          inchTable.classList.remove("slide-right");
          inchTable.classList.add("slide-right");
 
          cmTable.classList.add("hidden");
        }
      });
 
      cmToggle.addEventListener("click", function () {
        if (!cmToggle.classList.contains("active")) {
          cmToggle.classList.add("active");
          inchToggle.classList.remove("active");
          toggleContainer.classList.add("cm-active");
 
          cmTable.classList.remove("hidden");
          cmTable.classList.remove("slide-right");
          cmTable.classList.add("slide-right");
 
          inchTable.classList.add("hidden");
        }
      });
 
      // Close on overlay click
      overlay.addEventListener("click", function () {
        sizeChart.classList.remove("active");
        if(innerWidth<950){
            document.querySelector(".new-mob-bottom-main").setAttribute("style","display: flex !important");
        }
      });
 
      // Function to open size chart (call this from your button)

      }




// ---- for new design of desktop menu we need to chnage color or header a fonts ---
(() => {
    const d = document.querySelector(".header_cont-drawer"),
        l = document.querySelectorAll(".main-header .m-header-left ul li a");
    if (!d || !l.length) return;
    new MutationObserver(() =>
        l.forEach(
        (a) =>
            (a.style.color = d.classList.contains("active-cont")
            ? "var(--normal-text)"
            : ""),
        ),
    ).observe(d, { attributes: true });
})();

// ---- for new design of desktop menu we need to chnage color or header a fonts ---


// ----- when cart open remove fixed bottom header --- 
if (window.innerWidth <= 950) {
  const cartDrawer = document.querySelector('cart-drawer.drawer');
  const mobileBottomBar = document.querySelector('.new-mob-bottom-main');

  cartDrawer && mobileBottomBar &&
    new MutationObserver(() =>
      mobileBottomBar.style.display =
        cartDrawer.classList.contains('active') ? 'none' : ''
    ).observe(cartDrawer, { attributes: true });
}

// ----- when cart open remove fixed bottom header --- 




// blind-size-chart

document.addEventListener("DOMContentLoaded",()=>{
    let productInfo = document.querySelector(".blind-product")
    if(productInfo){
        
        let chartTabs = productInfo.querySelectorAll(".chart-tab");
        chartTabs.forEach((chartTab)=>{
            chartTab.addEventListener("click",()=>{
                productInfo.querySelector(".chart-tab.active").classList.remove("active");
                chartTab.classList.add("active");
                let chartVal = chartTab.getAttribute("data-type");
                let tableWrap = productInfo.querySelector(".size-table-wrapper");
                tableWrap.classList.remove("tshirt");
                tableWrap.classList.remove("shirt");
                tableWrap.classList.remove("track");
                tableWrap.classList.add(chartVal);
            })
        })

    }
})
function closeBlindChart(el){
    el.closest(".sizechart").classList.remove("active")
}

// blind-size-chart